exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-b9a771dc!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 611
// module chunks = 2